import React, {ReactElement} from 'react';
import {Props} from './Props';
import MapGL from '../../../../components/MapGl';
import {MapView} from '../../../../interfaces/Mapview';
import {MapFeature} from '../../../../interfaces/MapFeature';

export default class Map extends React.Component<Props> {
    onMapPositionUpdated = (viewport: MapView): void => {
        this.props.handleViewportChange(viewport);
    };

    onUserMapClick = (foundFeatures: MapFeature[], pointX: number, pointY: number): void => {
        this.props.onUserMapClick(foundFeatures, pointX, pointY);
    };

    render(): ReactElement {
        const {
            mapFlyToLocation,
            mapStyleUrl,
            mapLayers,
            mapSettings,
            dataSources,
            mapFilter,
            viewport,
            searchResults,
            showTrafficJamIcons,
            highlightFeatures,
            mapHasFinishedLoading,
            onUserHoverOverFeature,
            onUserExistsHoverOverFeature,
            onUserMapRightClick,
            numberOfFeaturesVisibleOnMap,
        } = this.props;

        return (
            <MapGL
                mapFlyToLocation={mapFlyToLocation}
                styleUrl={mapStyleUrl}
                mapLayers={mapLayers}
                mapSettings={mapSettings}
                dataSources={dataSources}
                showTrafficJamIcons={showTrafficJamIcons}
                mapFilter={mapFilter}
                searchResults={searchResults}
                highlightFeatures={highlightFeatures}
                viewport={viewport}
                mapHasFinishedLoading={mapHasFinishedLoading}
                updateMapPosition={this.onMapPositionUpdated}
                onUserMapClick={this.onUserMapClick}
                onUserHoverOverFeature={onUserHoverOverFeature}
                onUserExistsHoverOverFeature={onUserExistsHoverOverFeature}
                onUserMapRightClick={onUserMapRightClick}
                numberOfFeaturesVisibleOnMap={numberOfFeaturesVisibleOnMap}
            />
        );
    }
}
